import axios from "axios";
import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ALL_ORDER_VIEW_REQUEST,
  ALL_ORDER_VIEW_SUCCESS,
  ALL_ORDER_VIEW_FAIL,
  ORDER_BY_ID_SUCCESS,
  ORDER_UPDATE_REQUEST,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_FAIL,
  SERVERADDRESS,
  ADDRESS_DELIVER_SUCCESS,
} from "../constants";
// import { notifyFailure, notifySuccess } from "../components/toast";

export const createOrder = (obj, navigate, callback) => async (dispatch) => {
  dispatch({
    type: ORDER_CREATE_REQUEST,
  });
  try {
    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/order/createOrder`,
      obj
    );
    dispatch({
      type: ORDER_CREATE_SUCCESS,
      payload: data,
    });
    callback && callback(data.id);
    navigate("/order-confirm");
  } catch (err) {
    console.log(err, "err");
    //   notifyFailure(err.response.data.message);
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload: err,
    });
  }
};

export const getAllOrders = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_ORDER_VIEW_REQUEST,
  });
  try {
    console.log(obj, "obj");

    const { data } = await axios.get(
      `${SERVERADDRESS}/v1/order/getAllOrders${
        obj.storeId ? `?storeId=${obj.storeId}` : ""
      }`,
      obj
    );

    localStorage.setItem("orders", JSON.stringify(data.slice(0, 200)));
    dispatch({
      type: ALL_ORDER_VIEW_SUCCESS,
      payload: data.slice(0, 200),
    });
    callback && callback(data);
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_ORDER_VIEW_FAIL,
      payload: err,
    });
  }
};

// GET ORDER BY ID
export const setOrderData = (obj) => async (dispatch) => {
  dispatch({
    type: ORDER_BY_ID_SUCCESS,
    payload: obj,
  });
};

export const updateOrderById = (obj, handleSuccess) => async (dispatch) => {
  dispatch({
    type: ORDER_UPDATE_REQUEST,
  });
  try {
    const { data } = await axios.patch(
      `${SERVERADDRESS}/v1/order/updateOrderById`,
      obj
    );
    handleSuccess();
    // notifySuccess("Updated successfully !");
    dispatch({
      type: ORDER_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    // console.log(err);
    // notifyFailure(err?.response?.data?.message);
    dispatch({
      type: ORDER_UPDATE_FAIL,
      payload: err,
    });
  }
};

export const setAddress = (obj) => async (dispatch) => {
  dispatch({
    type: ADDRESS_DELIVER_SUCCESS,
    payload: obj,
  });
};
